import { css } from 'styled-components';
import { fontSize, codeFontFamily as codeFontFamilyProvider, typography } from '@atlaskit/theme';

export const small = css`
    /* stylelint-disable scale-unlimited/declaration-strict-value */
    font-size: 12px;
`;

export const regular = css`
    font-size: ${fontSize()}px;
`;

export const medium = css`
    font-size: 16px;
`;

export const mediumLarge = css`
    font-size: 18px;
`;

export const large = css`
    font-size: 20px;
`;

export const xlarge = css`
    font-size: 24px;
`;

export const xsmall = css`
    font-size: 11px;
`;

export const codeFontFamily = codeFontFamilyProvider();

export const h800 = typography.h800;
export const h700 = typography.h700;
export const h600 = typography.h600;
export const h500 = typography.h500;
export const h400 = typography.h400;
export const h300 = typography.h300;
export const h200 = typography.h200;
export const h100 = typography.h100;
